Ext.define('SA.view.Tutorial', {
    alias: 'widget.tutorial',

    transitionDelay: 500,

    constructor({notice}) {
        this.notice = notice;

        this.el = document.body.appendChild(document.createElement('dialog'));
        this.el.classList.add('sa-tutorial');

        this.el.innerHTML = [
            '<button class="sa-tutorial-close-button" aria-label="Close" autofocus></button>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-navless sa-tutorial-slide-1" data-auto-advance-delay="4000">',
                '<h3 class="sa-tutorial-title">Welcome to SimplyAnalytics</h3>',
                '<img class="sa-tutorial-logo-large" src="static/theme/images/sa_logo_white.svg">',
            '</div>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-2">',
                '<h3 class="sa-tutorial-title">Here’s a quick tour of SimplyAnalytics.</h3>',
                '<div class="sa-tutorial-text">',
                    'This very brief overview will get you well on your way to<br>',
                    'becoming a SimplyAnalytics expert.',
                '</div>',
                '<div class="sa-tutorial-browser-window" data-content="slide2.jpg"></div>',
            '</div>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-3">',
                '<h3 class="sa-tutorial-title">Get started in seconds.</h3>',
                '<div class="sa-tutorial-text">',
                    'Use the &ldquo;New Project Wizard&rdquo; to get up and running quicker than ever. ',
                    'Just enter the locations you are interested in and we do the rest.',
                '</div>',
                '<div class="sa-tutorial-browser-window" data-content="slide3.gif"></div>',
            '</div>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-4">',
                '<h3 class="sa-tutorial-title">Data, Locations, and Businesses</h3>',
                '<div class="sa-tutorial-text">',
                    'The left side of the screen houses the &ldquo;building blocks&rdquo; of SimplyAnalytics. ',
                    'Use this area to find data, locations, and businesses to add to your project.',
                '</div>',
                '<div class="sa-tutorial-browser-window" data-content="slide4.gif"></div>',
            '</div>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-5">',
                '<h3 class="sa-tutorial-title">Views</h3>',
                '<div class="sa-tutorial-text">',
                    'The right side of the screen contains your &ldquo;views.&rdquo; ',
                    'These are different ways to view your data, such as maps, rankings, reports, and charts. ',
                    'We will auto-create some views to get you started, but you can always make more by clicking on the &ldquo;New View&rdquo; button.',
                '</div>',
                '<div class="sa-tutorial-browser-window" data-content="slide5.gif"></div>',
            '</div>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-6">',
                '<h3 class="sa-tutorial-title">Your workspace</h3>',
                '<div class="sa-tutorial-text">',
                    'The large center area is where you will view your maps, tables and reports. ',
                    'Most reports have some settings at the top that you can easily change. ',
                    'For example, in a map view you can easily change your location or data variable using the dropdown boxes. ',
                    'Give it a try after you create your first project.',
                '</div>',
                '<div class="sa-tutorial-browser-window" data-content="slide6.gif"></div>',
            '</div>',

            '<div class="sa-tutorial-slide sa-tutorial-slide-navless sa-tutorial-slide-7">',
                '<h3 class="sa-tutorial-title">Thanks for watching this tutorial!</h3>',
                '<div class="sa-tutorial-text">',
                    'Your SimplyAnalytics account is ready to use.',
                '</div>',
                '<div class="sa-tutorial-done-button-wrap">',
                    '<button class="sa-tutorial-done-button">Go to SimplyAnalytics</button>',
                '</div>',
                '<div class="sa-tutorial-replay-button-wrap">',
                    '<button class="sa-tutorial-replay-button">Replay Tutorial</button>',
                '</div>',
                '<img class="sa-tutorial-logo-small" src="static/theme/images/sa_logo_white.svg">',
            '</div>',

            '<div class="sa-tutorial-nav">',
                '<div class="sa-tutorial-progress-bar">',
                    '<div class="sa-tutorial-progress-bar-indicator"></div>',
                '</div>',
                '<div class="sa-tutorial-nav-buttons-wrap">',
                    '<button type="button" class="sa-tutorial-nav-button sa-tutorial-back-button">Back</button>',
                    '<button type="button" class="sa-tutorial-nav-button sa-tutorial-next-button">Next</button>',
                '</div>',
            '</div>'
        ].join('\n');

        this.slides = [];
        this.activeIndex = 0;

        this.buildSlides();

        this.readyInterval = setInterval(() => {
            var ready = this.slides.every(slide => !slide.image || slide.image.complete);

            if (ready) {
                clearInterval(this.readyInterval);

                this.goToBeginning();
            }
        }, 10);

        this.initEvents();
        this.el.showModal();
    },

    buildSlides() {
        var slideEls = this.el.querySelectorAll('.sa-tutorial-slide');

        Ext.Array.from(slideEls).forEach(slideEl => {
            var browserEl = slideEl.querySelector('.sa-tutorial-browser-window'),
                appImageFilename = browserEl && browserEl.getAttribute('data-content'),
                img = null,
                textEl = slideEl.querySelector('.sa-tutorial-text');

            if (textEl) {
                localizeRecursive(textEl);
            }

            if (appImageFilename) {
                img = new Image();
                img.src = 'static/theme/images/tutorial/' + appImageFilename;
            }

            this.slides.push({
                element: slideEl,
                image: img
            });
        });

        function localizeRecursive(el) {
            Ext.Array.from(el.childNodes).forEach(node => {
                if (node.childNodes.length) {
                    localizeRecursive(node);
                }
                else {
                    node.textContent = SA.localize(node.textContent);
                }
            });
        }
    },

    goToFirstSlide() {
        this.prepareTransitionTo(1);
    },

    initEvents() {
        var el = this.el;

        el.addEventListener('close', () => this.onClose());
        el.querySelector('.sa-tutorial-close-button').addEventListener('click', () => this.el.close());
        el.querySelector('.sa-tutorial-back-button').addEventListener('click', () => this.viewPrevious());
        el.querySelector('.sa-tutorial-next-button').addEventListener('click', () => this.viewNext());
        el.querySelector('.sa-tutorial-done-button').addEventListener('click', () => this.el.close());
        el.querySelector('.sa-tutorial-replay-button').addEventListener('click', () => this.goToFirstSlide());
    },

    goToBeginning() {
        this.transitionTo(0);
    },

    onClose() {
        var newProjectWindow = Ext.ComponentQuery.query('new-project-locations-window')[0];

        if (this.notice) {
            this.notice.markViewed();

            this.notice = null;
        }

        clearInterval(this.readyInterval);
        clearTimeout(this.autoAdvanceTimeout);
        clearTimeout(this.transitionTimeout);

        this.el.remove();

        if (newProjectWindow) {
            var focusableElement = newProjectWindow.down('close-button');

            focusableElement?.el.dom.focus();
        }

    },

    prepareTransitionTo(index) {
        var me = this,
            slides = this.slides,
            activeSlideEl = slides[this.activeIndex].element;

        if (index < 0 || index > slides.length - 1) {
            return;
        }

        if (this.transitionPending) {
            return;
        }

        this.transitionPending = true;

        Ext.fly(activeSlideEl).removeCls('sa-tutorial-slide-active');
        Ext.fly(activeSlideEl).addCls('sa-tutorial-slide-leaving');

        refreshNavVisibility();

        this.transitionTimeout = setTimeout(() => {
            this.transitionPending = false;

            this.transitionTo(index);
        }, this.transitionDelay);

        function refreshNavVisibility() {
            var backEl = me.el.querySelector('.sa-tutorial-back-button'),
                navEl = me.el.querySelector('.sa-tutorial-nav'),
                isNavless = Ext.fly(slides[index].element).hasCls('sa-tutorial-slide-navless');

            Ext.fly(backEl).ifCls(index !== 1, 'sa-tutorial-back-button-visible');
            Ext.fly(navEl).ifCls(!isNavless,'sa-tutorial-nav-visible');
        }
    },

    transitionTo(index) {
        var slides = this.slides,
            slide = slides[index],
            slideEl = slide.element,
            browser = slideEl.querySelector('.sa-tutorial-browser-window'),
            percentageComplete = getPercentageComplete(),
            autoAdvanceDelay = slideEl.getAttribute('data-auto-advance-delay');

        this.activeIndex = index;

        slides.forEach(slide => {
            Ext.fly(slide.element).removeCls(['sa-tutorial-slide-current', 'sa-tutorial-slide-active', 'sa-tutorial-slide-leaving']);
        });

        Ext.fly(slideEl).addCls(['sa-tutorial-slide-current', 'sa-tutorial-slide-active']);

        if (browser && slide.image) {
            browser.innerHTML = [
                '<div class="sa-tutorial-browser-viewport">',
                    '<img class="sa-tutorial-browser-content" src="' + slide.image.src + '">',
                '</div>'
            ].join('');
        }

        this.el.querySelector('.sa-tutorial-progress-bar-indicator').style.width = percentageComplete + '%';

        if (autoAdvanceDelay) {
            this.autoAdvanceTimeout = setTimeout(() => this.viewNext(), autoAdvanceDelay);
        }

        function getPercentageComplete() {
            var slide = index - 1, 
                totalSlides = slides.length - 2;

            return (slide / totalSlides) * 100;
        }
    },

    viewNext() {
        this.prepareTransitionTo(this.activeIndex + 1);
    },

    viewPrevious() {
        this.prepareTransitionTo(this.activeIndex - 1);
    }
});
